<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.62543 12.7504L15.0004 1.12537L27.3754 12.7504V28.5004H19.5004V19.1254L15.0004 17.2504L10.5004 19.1254V28.5004H2.62543V12.7504Z"
      fill="#040A34"
    />
    <path
      d="M28.9025 14.0729L15 1.09753L1.0976 14.0729"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0699 17.781H15.9235C17.9706 17.781 19.6308 19.4406 19.6308 21.4882V28.9027H10.3625V21.4882C10.3625 19.4406 12.0228 17.781 14.0699 17.781Z"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.0459 12.3475V27.0467C27.0459 28.0705 26.216 28.9003 25.1922 28.9003H4.80196C3.77812 28.9003 2.9483 28.0705 2.9483 27.0467V12.3475"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
